import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addEmployee, updateEmployee } from "network/service";

export default function AddEditEmployee(props) {
  const [newField, setNewField] = useState({ name: "", code: "", is_active: true });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();

  const validate = () => {
    let isValid = true;
    const newErrors = {};

    if (newField.name.trim() === "") {
      newErrors.name = "Employee name is required";
      isValid = false;
    }
    if (newField.code.trim() === "") {
      newErrors.code = "Employee code is required";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const submit = async () => {
    try {
      if (!validate()) return;
      setLoading(true);
      const payload = {
        name: newField.name.trim(),
        code: newField.code.trim().toUpperCase(),
        is_active: !!newField.is_active,
      };
      if (props.details && props.details._id) {
        await updateEmployee(props.details._id, payload);
        showNotification("success", "Success", "Updated employee successfully");
      } else {
        await addEmployee(payload);
        showNotification("success", "Success", "Added employee successfully");
      }
      props.handlesuccess();
      props.handleclose();
    } catch (err) {
      console.log(err);
      showNotification("error", "Error", "Failed to save employee");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.details) {
      setNewField({
        name: props.details.name || "",
        code: props.details.code || "",
        is_active: props.details.is_active !== false,
      });
      return;
    }
    setNewField({ name: "", code: "", is_active: true });
  }, [props.details]);

  return (
    <Dialog
      id="modal-display"
      open={props.isopen}
      aria-labelledby="form-dialog-title"
      aria-describedby="modal-modal-description"
      maxWidth="90%"
      maxHeight="90%"
      onClose={props.handleclose}
      disableBackdropClick
    >
      <div>
        <DialogTitle>{props.details ? "Edit Employee" : "Add Employee"}</DialogTitle>
      </div>
      <DialogContent sx={{ minWidth: 500 }}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <MDInput
              label="Employee Name"
              value={newField.name}
              fullWidth
              onChange={(e) => {
                setNewField({ ...newField, name: e.target.value });
              }}
              helperText={
                <FormHelperText sx={{ color: "red", fontWeight: 800, margin: 0 }}>
                  {errors.name}
                </FormHelperText>
              }
            />
          </Grid>
          <Grid item>
            <MDInput
              label="Employee Code"
              value={newField.code}
              fullWidth
              onChange={(e) => {
                setNewField({ ...newField, code: e.target.value.toUpperCase() });
              }}
              helperText={
                <FormHelperText sx={{ color: "red", fontWeight: 800, margin: 0 }}>
                  {errors.code}
                </FormHelperText>
              }
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={!!newField.is_active}
                  onChange={(e) => {
                    setNewField({ ...newField, is_active: e.target.checked });
                  }}
                  color="info"
                />
              }
              label={newField.is_active ? "Active" : "Inactive"}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <MDButton variant="gradient" color="error" onClick={props.handleclose}>
          <Icon>close</Icon>&nbsp;Cancel
        </MDButton>
        <MDButton variant="gradient" color="success" onClick={submit} disabled={loading}>
          <Icon>save</Icon>&nbsp;Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
